import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
    constructor(private router: Router) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(error => {
                // If we receive a 401 error, redirect to the unauthorized page
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    void this.router.navigate(['/unauthorized']);
                }
                // Re-throw the error for other error handlers
                return throwError(() => error);
            })
        );
    }
}
